import React from 'react';
import { SignoutCallbackComponent } from 'redux-oidc';

import { session } from '_helpers';

const SignoutCallbackPage = () => (
  <SignoutCallbackComponent
    userManager={session.userManager}
    successCallback={() => {
      console.log('Logged out');
    }}
    errorCallback={(error) => {
      console.error('Logged out error', error);
    }}
  >
    <div />
  </SignoutCallbackComponent>
);

export default SignoutCallbackPage;
